import { ReduxStore } from 'store/types';

function signInIsLoading(state: ReduxStore): boolean {
  return state.auth.config.isLoading;
}

export default signInIsLoading;
